import { action } from 'app/actions';

export const GET_SCHOOLS_BY_CONTRACT = 'managerDashboard/GET_SCHOOLS_BY_CONTRACT';
export const getSchoolsByContract = (payload) => action(GET_SCHOOLS_BY_CONTRACT, { payload });

export const GET_APPLICATIONS_BY_CONTRACT_SCHOOLS =
  'managerDashboard/GET_APPLICATIONS_BY_CONTRACT_SCHOOLS';
export const getApplicationsByContractSchools = (payload) =>
  action(GET_APPLICATIONS_BY_CONTRACT_SCHOOLS, { payload });

export const GET_RETURNS_AVERAGE_INFO = 'managerDashboard/GET_RETURNS_AVERAGE_INFO';
export const getReturnsAverageInfo = (payload) => action(GET_RETURNS_AVERAGE_INFO, { payload });

export const GET_RETURNS_AVERAGE_INFO_SPECIFIC = 'managerDashboard/GET_RETURNS_AVERAGE_INFO_SPECIFIC';
export const getReturnsAverageInfoSpecific = (payload) =>
  action(GET_RETURNS_AVERAGE_INFO_SPECIFIC, { payload });
